<template>
  <div class="header-wrapper">
    <div class="left">
      <div class="brand">
        <div class="logo">TD</div>
        <div class="name">管理系统</div>
      </div>
      <el-button type="text" icon="el-icon-s-fold" @click="toggleCollapse"></el-button>
    </div>
    <div class="right">
    <span class="welcome-text">欢迎回来，{{ userName }}</span>
    <el-dropdown>
      <i class="el-icon-setting" style="margin-left: 15px"></i>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item @click.native="handleLogout">退出登录</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { resetRouter } from '@/router'
export default {
  name: 'AppHeaderNav',
  computed: {
    userName() {
      return this.$store.getters.userInfo.username || '管理员';
    }
  },
  methods: {
    ...mapActions('user', ['logout']),
    toggleCollapse() {
      this.$emit('toggle-collapse')
    },
    // 在组件中的登出方法
async handleLogout() {
  try {
    await this.$confirm('确定要退出登录吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    });
    
    // 调用退出登录方法
    await this.logout();
    
    // 重置路由（清除动态路由）
    if (typeof resetRouter === 'function') {
      resetRouter();
    }
    
    // 清除所有本地存储
    this.clearAllState();
    
    // 跳转到登录页面
    this.$router.push('/login');
    this.$message.success('退出登录成功');
    
    // 强制刷新页面，确保所有状态被清理
    setTimeout(() => {
      window.location.reload();
    }, 100);
    
  } catch (error) {
    if (error !== 'cancel') {
      console.error('退出登录失败:', error);
      this.$message.error('退出登录失败');
    } else {
      this.$message.info('已取消退出');
    }
  }
},

// 辅助方法：清理所有状态
clearAllState() {
  // 清除store中的状态
  this.$store.commit('user/SET_USER_INFO', {});
  this.$store.commit('user/SET_ROLES', []);
  this.$store.commit('user/SET_PERMISSIONS', []);
  this.$store.commit('permission/RESET_ROUTES');
  
  // 清除所有本地存储
  const keysToRemove = [
    'user_info', 'user_role', 'user_roles',
    'token', 'refresh_token', 'vuex'
  ];
  
  keysToRemove.forEach(key => {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  });
  
  // 清除cookie
  document.cookie.split(';').forEach(cookie => {
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
  });
}
  }
};
</script>

<style scoped>
.header-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}

.left {
  display: flex;
  align-items: center;
}

.brand {
  display: flex;
  align-items: center;
  margin-right: 12px;
}

.logo {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  background: linear-gradient(135deg, #409EFF, #66b1ff);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
  margin-right: 8px;
}

.name {
  font-size: 16px;
  font-weight: 600;
  color: var(--color-text);
}

.welcome-text {
  color: var(--color-text-secondary);
}

.el-icon-setting {
  font-size: 18px;
  color: var(--color-text-secondary);
  cursor: pointer;
}
</style>
